import {
  CLIENT_USAGE,
  CLIENT_USERS,
} from 'constants/routes.js';
import { CLIENT_PERMISSIONS } from 'shared-permissions';
const {
  USAGE_CLIENT,
  EDIT_USERS_CLIENT,
} = CLIENT_PERMISSIONS;

const CLIENT_ROUTES = [
  {
    title: 'Usage',
    icon: 'insights',
    route: CLIENT_USAGE,
    requiredPermission: USAGE_CLIENT,
    allowSuperAdmin: true,
  },
  {
    title: 'sidebarComponent.settingsTitle',
    icon: 'settings',
    allowSuperAdmin: true,
    align: 'bottom',
    submenu: [
      {
        title: 'sidebarComponent.usersSettingsTitle',
        route: CLIENT_USERS,
        requiredPermission: EDIT_USERS_CLIENT,
        requiredFeatures: [],
        allowSuperAdmin: true,
      },
    ],
  },
];

export default CLIENT_ROUTES;
